import { Flex } from "antd";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import AppButton from "../../common/AppButton";
import WarehouseDockForm from "./WarehouseDockForm";
import WarehouseDocksTable from "./WarehouseDocksTable";

const WarehouseDocksPanel = () => {
  const { state: { warehouseId } } = useLocation();
  const [isModifying, setIsModifying] = useState(false);
  const [dockId, setDockId] = useState(null);

  const handleIsModifying = () => setIsModifying(!isModifying);

  const handleDockIdChange = (dockId) => setDockId(dockId);

  return (
    <>
      {isModifying ?
        (<Flex justify="center">
          <WarehouseDockForm dockId={dockId}
                             warehouseId={warehouseId}
                             handleDockIdChange={handleDockIdChange}
                             handleIsModifying={handleIsModifying} />
        </Flex>) :
        (<>
          <AppButton className="panel-new-button" variant="new" onClick={handleIsModifying}>
              New
          </AppButton>
          <WarehouseDocksTable handleIsModifying={handleIsModifying}
                               handleDockIdChange={handleDockIdChange} />
        </>)
      }
    </>
  );
};

export default WarehouseDocksPanel;